<template>
  <div>
    <p>
      Thousands are helping send minifigs into LEGO Universe to battle the dark and destructive Maelstrom!
    </p>
    <poll-images id="bfc231eb-f792-4c4a-a862-328f5be36950"></poll-images>
    <poll id="bfc231eb-f792-4c4a-a862-328f5be36950"></poll>
  </div>
</template>
